import { render } from "./grid_desc.vue?vue&type=template&id=342e6811"
import script from "./grid_desc.vue?vue&type=script&lang=js"
export * from "./grid_desc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__